export const formMessageError = {
    "name" : {
        "empty" : "名前フィールドを空白のままにすることはできません (Vui lòng nhập tên)",
        "minlength" : "名前フィールドは5文字以上である必要があります (Trường tên ít nhất phải có 5 kí tự)"
    },
    "email" : {
        "empty" : "あなたのメールアドレスを入力してください (Vui lòng nhập email)",
        "type" : "正しいメール形式を入力してください (Email không đúng định dạng)",
    },
    "password" : {
        "empty" : "パスワードを入力してください (Vui lòng nhập password)",
        "minlength" : "パスワードには最低8文字が必要です (Password phải có ít nhất 8 kí tự)",
        "confirm_password" : "パスワードが一致しません (mật khẩu không matching)"
    }
};